<template>
  <div class="act">
    <el-tabs v-model="activeName" class="act-tabs" type="card">
      <el-tab-pane label="联盟活动" name="first">
        <div class="act-con" v-loading="loading">
          <div
            v-for="(item, index) in acts"
            :key="index"
            class="act-item flex flex-row"
            @click="actClick(item)"
          >
            <div class="act-img">
              <img v-if="item.activityImage" :src="item.activityImage" />
              <img v-else :src="$oss('common/empty-img-news.jpg')" />
            </div>
            <div class="flex-1 flex flex-column flex-between">
              <div class="act-title">{{ item.activityTitle }}</div>
              <div class="act-time">
                发布时间：{{ item.createTime | transformTime }}
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 分页-->
    <Pagination
      :total="totalItem"
      :page="page"
      @pageIndexChange="handlePageChange"
    />
  </div>
</template>
<script>
import { parseTime } from "@/utils/index";
import { allianceActsList } from "@/api/allianceZone";
import Pagination from "@/components/Pagination/index";
export default {
  filters: {
    transformTime(val) {
      return parseTime(val, "{y}-{m}-{d}");
    },
  },
  components: {
    Pagination,
  },
  data() {
    return {
      totalItem: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      activeName: "first",
      acts: [],
      loading: true,
      detailId: null,
    };
  },
  created() {
    this.detailId = this.$route.query.id;
    this.getActList();
  },
  methods: {
    actClick({ leagueActivityId }) {
      this.$router.push({
        name: "allianceActDetail",
        query: { id: leagueActivityId, detailId: this.detailId },
      });
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getActList();
    },
    async getActList() {
      this.loading = true;
      const { list, totalItem } = await this.$axios
        .get(allianceActsList, {
          ...this.page,
          leagueId: this.detailId,
        })
        .finally(() => {
          this.loading = false;
        });
      this.totalItem = totalItem;
      this.acts = list;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
$max-w: 375px;
.act {
  margin-bottom: 20px;
  ::v-deep .el-tabs__header .el-tabs__item {
    font-size: 18px !important;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: $theme-color;
    color: #fff;
    border: 1px solid $theme-color;
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 0px;
  }
  ::v-deep .el-tabs__content {
    background: #fff;
    border: none;
    padding: 16px;
  }
  &-tabs {
    margin-bottom: 20px;
    // min-height: 300px;
  }
  &-con {
    padding-top: 5px;

    display: grid;
    grid-template-columns: repeat(2, calc(50% - 8px));
    gap: 15px;
  }
  &-item {
    cursor: pointer;
    // border: 1px solid $border-color;
    box-shadow: 0px 0px 12px 1px rgba(175, 211, 255, 0.3);
    padding: 15px;
    border-radius: 8px;
  }
  &-img {
    width: 250px;
    height: 140px;
    margin-right: 15px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-title {
    font-weight: bold;
    font-size: 15px;
    // > .time {
    //   color: $font-color-gray;
    // }
  }
  &-time {
    color: $font-color-gray;
  }
}
</style>
